
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Scan from './pages/Scan/Scan'; 
import Login from './pages/Login/Login'; 
import Dashboard from './pages/Dashboard/Dashboard';
import Tamu from './pages/Tamu/Tamu';
import PrivateRoute from './components/PrivateRoute'; // make sure this exists

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route 
          path="/" 
          element={
            <PrivateRoute usherOnly>
              <Scan />
            </PrivateRoute>
          } 
        />
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        />
        <Route
          path="/tamu"
          element={
            <PrivateRoute>
              <Tamu />
            </PrivateRoute>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
